import React from "react";
import styled from "styled-components";

import { Categories } from "./constants";
import { connectStreamLabs } from "./providers/streamlabs";
import * as Colors from "../reusable/colors";
import { tokens } from "./store";

const Button = styled.a`
  background-color: ${Colors.primary};
  padding: 10px 15px;
  border: 1px solid ${Colors.separatorDark};
  color: ${Colors.Text};
  display: inline-block;
`;

const StreamLabsConnect = props => {
  return tokens.get("streamlabs") ? null : (
    <Button onClick={connectStreamLabs}>Connect StreamLabs</Button>
  );
};

const customs = {
  [Categories.Donation]: [StreamLabsConnect]
};

export default ({ cat }) => {
  return (
    <div>{customs[cat] && customs[cat].map((c, i) => React.createElement(c, { key: i }))}</div>
  );
};



// WEBPACK FOOTER //
// ./src/spreadsheet/customs.js